import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import SpaLoader from "../../Components/Loaders/SpaLoader";
import { ShowSPA } from "../../API/SPAAPI";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import BannerHome from "../../new-components/banner-home/BannerHome";
import SpaServicesList from "../../Components/SpaServicesList";
import SpaFallbackImg from "../../assets/new_imgs/SPA1.jpg";
import "../food-and-beverages/FoodAndBeverages.scss";
import { trackCategoryViewed } from "../../utils/mixpanel";

function SpaService() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const spa_uuid = params.spa_uuid;
  const lang = localStorage.getItem("lang");

  let spa;
  let images;
  let text;
  let spaServices;
  let spaCategories;
  const { data, isLoading, error } = ShowSPA(room_uuid, spa_uuid, lang);

  if (!isLoading) {
    if (error) {
      if (error?.response.status === 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        spa = data.data.data.spa;
        images = spa?.header_images;
        text = data.data.data.header_title;
        spaServices = spa.services;
        spaCategories = spa.categories;
      }
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (!isLoading && !error && spa) {
      trackCategoryViewed({
        category_id: 4,
        category_name: text || "",
        category_type: "spa",
      });
    }
  }, [isLoading]);

  const hasCategories = spaCategories?.length > 0;

  return (
    <div className="food pb-2">
      <Title title={text} />
      {isLoading ? (
        <SpaLoader />
      ) : hasCategories ? (
        /* Categories list the way the restaurant booking page does: straight
           inside `.food`, with no `main` wrapper capping the width. */
        <>
          <BannerHome className={"px-2"} headerImages={images} />
          <div className="box_food">
            {spaCategories?.map((category) => {
              const image =
                category.image ||
                category.services?.[0]?.image ||
                SpaFallbackImg;
              return (
                <div
                  key={category.id}
                  style={{
                    position: "relative",
                    margin: "auto",
                    marginBottom: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    navigate(
                      `/${room_uuid}/hotel-services/spa/${spa_uuid}/category/${category.id}`,
                    )
                  }
                >
                  <BannerHome
                    headerImages={[{ image }]}
                    imageOverllay={true}
                    isBookingList={true}
                  />
                  <div className="text_food" style={{ bottom: "15px" }}>
                    <h5>{category.name}</h5>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        /* Spas without categories keep listing their services directly. */
        <main className="home-main bg-white back-white pad-top-0">
          <BannerHome className={"px-2"} headerImages={images} />
          <SpaServicesList
            services={spaServices}
            room_uuid={room_uuid}
            spa_uuid={spa_uuid}
            theme
          />
        </main>
      )}
      <NewFooter />
    </div>
  );
}
export default SpaService;
